
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"11"}},[_c('path',{attrs:{"fill":"currentColor","d":"M1.429 6.875L5.718 11l1.43-1.375L3.87 6.473H15V4.527H3.87l3.278-3.152L5.718 0 0 5.5z"}})])
      }
    
      }
    